import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import MODALS from '../../../../modals/constants/modals';
import styles from './ImagesSlider.module.sass';
import './SlickOverrides.sass';
import Badge from '../../../../ui_kit/badge/Badge';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import { modalsActions } from '../../../../modals/actions';
import stickerImage from '../../../../../images/product/as_seen_on_e_1.png';

const YAUPON_SLUG = 'yaupon-tea-glow-awakening-moisturizer';

function Image(props) {
  useEffect(() => {
    window.lazyLoad.update();
  }, []);

  const { onClick, image, showSticker } = props;

  return (
    <ClickableDiv className={styles['image-wrapper']} onClick={onClick}>
      <div className={styles.image}>
        <picture>
          <source suppressHydrationWarning data-srcset={image.urlWebp} srcSet={image.placeholderWebp} type="image/webp" />
          <img suppressHydrationWarning className="lazyload blur" data-src={image.url} src={image.placeholder} alt="product" />
        </picture>
        { showSticker && (
          <div className={styles.sticker}>
            <img suppressHydrationWarning className="lazyload blur" data-src={stickerImage} src={stickerImage.placeholder} alt="product" />
          </div>
        )}
      </div>
    </ClickableDiv>
  );
}

Image.propTypes = {
  onClick: PropTypes.func.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string,
    urlWebp: PropTypes.string,
    placeholder: PropTypes.string,
    placeholderWebp: PropTypes.string,
  }).isRequired,
  showSticker: PropTypes.bool.isRequired,
};

function ImagesSlider(props) {
  const {
    images, backgroundImage, title, openImagesSliderModal, badge, slug,
  } = props;

  const onImageClick = (index) => {
    openImagesSliderModal(images, index);
  };

  const customPagingImgs = (i) => (
    <ClickableDiv className={styles['image-preview-wrapper']}>
      <Image
        key={images[i]}
        image={images[i]}
        showSticker={false}
        onClick={() => {}}
      />
    </ClickableDiv>
  );

  return (
    <div className={`product-images-slider ${styles['images-slider']}`}>
      <div className={styles['background-image']}>
        <img src={backgroundImage} alt="product" />
      </div>
      { badge && (
        <Badge className={styles.badge} text={badge} color="blue" />
      )}
      <div className={styles['click-to-zoom']}>
        Click image to zoom in
      </div>
      <div className={styles.title}>
        {title}
      </div>
      <div className={styles['slider-wrapper']}>
        <Slider
          customPaging={customPagingImgs}
          dots
          infinite
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          className={styles.slider}
        >
          {images.map((image, index) => (
            <Image
              key={image}
              image={image}
              showSticker={slug === YAUPON_SLUG && index === 0}
              onClick={() => { onImageClick(index); }}
            />
          ))}
        </Slider>
      </div>
      { images.map((image) => (<link key={image.url} itemProp="image" href={image.url} />))}
    </div>
  );
}

ImagesSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    placeholder: PropTypes.string,
  })).isRequired,
  backgroundImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  openImagesSliderModal: PropTypes.func.isRequired,
  badge: PropTypes.string,
  slug: PropTypes.string.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  openImagesSliderModal: (images, activeImageId) => dispatch(modalsActions.openModalRequest({
    modal: MODALS.IMAGES_SLIDER,
    data: { images, activeImageId },
  })),
});

export default connect(null, mapDispatchToProps)(ImagesSlider);
